export const saleFinalDocStages = [17, 18]
